const comments = [
  {
    name: '影迷小王',
    avatar: 'W',
    time: '2小时前',
    text: '69视频真的太方便了！以前要找各种资源得翻好几个网站，现在一个平台全搞定。更新速度也快，昨天上映的新片今天就能看到，画质还特别清楚。强烈推荐给所有爱看电影的朋友！',
    tag: '资深影迷',
  },
  {
    name: '追剧达人阿琳',
    avatar: 'A',
    time: '5小时前',
    text: '一直在用69视频追剧，丝瓜视频和蓝莓视频的资源都很全，最重要的是手机上看一点都不卡。分类也很清楚，找自己喜欢的类型特别方便。最近又在上面发现了好几部冷门好片！',
    tag: '追剧爱好者',
  },
  {
    name: '动漫宅老张',
    avatar: 'L',
    time: '1天前',
    text: '作为资深动漫迷，69视频的动漫专区简直是我的宝藏。糖心视频和黑桃视频上新番的速度非常快，画质也很顶。而且还有纪录片频道，偶尔换换口味看看自然纪录片也很享受。',
    tag: '动漫达人',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
            读者心声
          </h2>
          <div className="space-y-4">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl p-5 border border-background-200"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-800">{comment.name}</span>
                      <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                        {comment.tag}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}